import React from "react";
import { FaArrowDown } from "react-icons/fa";

const NeedHelpSection = () => {
  return (
    <div className="py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-blue-600 rounded-2xl p-12 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-6">
            Need Help Choosing The Right Course?
          </h2>
          <p className="text-sm md:text-base text-blue-100 mb-8 max-w-2xl mx-auto">
            Our education counselors are here to help you choose the perfect course 
            that aligns with your career goals and interests.
          </p>
            <FaArrowDown className="w-6 h-6 mx-auto text-white" />
        </div>
      </div>
    </div>
  );
};

export default NeedHelpSection;
